module.exports = __webpack_public_path__ + "static/media/gst bills.64dbb4e2.png";